import { get, head, isEmpty, isEqual, compose, getOr, map } from 'lodash/fp';
import { string } from 'fp-ts';
import {
    CardPaymentMethod,
    PaymentMethod,
    PaymentRequestState,
    PaymentState,
    SepaPaymentMethod,
} from '@mews-commander/data-access';
import { parsePaymentCardExpirationDate } from '@mews/framework';
import { CreditCardType } from '@mews-commander/legacy-data-structures';
import { UNSPECIFIED_CREDIT_CARD_VALUE } from '@mews-commander/legacy-entities/src/ducks/payments';
import { NEW_CREDIT_CARD_VALUE } from './constants';

export const prepareGatewayCardPayload = ({
    creditCardHolderName,
    creditCardExpiration,
    creditCardFormat,
    creditCardNumber,
    creditCardCvv,
    clientToken,
    customerId,
    elementId,
}: $TSFixMe) => ({
    elementId,
    number: creditCardNumber,
    holderName: creditCardHolderName,
    expiration: creditCardExpiration,
    cvv: creditCardCvv,
    format: creditCardFormat,
    customerId,
    clientToken,
});

export const prepareManualCardPayload = ({
    creditCardHolderName,
    creditCardExpiration,
    creditCardFormat,
    creditCardNumber,
    creditCardType,
    customerId,
    elementId,
}: $TSFixMe) => ({
    elementId,
    customerId,
    type: creditCardType,
    obfuscatedNumber: creditCardNumber,
    ...(creditCardHolderName && { holderName: creditCardHolderName }),
    format: creditCardFormat,
    expiration: creditCardExpiration,
});

export const getDefaultCard = (paymentCards: $TSFixMe) =>
    isEmpty(paymentCards) ? NEW_CREDIT_CARD_VALUE : get('id', head(paymentCards));

export const mapCardEnumValues = map((creditCardTypeName: $TSFixMe) => CreditCardType.getByName(creditCardTypeName));

export const isVerifyingState = compose(isEqual(PaymentState.Verifying), getOr('', 'state'));

export const isPaymentRequestUnresolved = (state: PaymentRequestState) => state === PaymentRequestState.Pending;

export const isNewCard = (id: string) => string.Eq.equals(id, NEW_CREDIT_CARD_VALUE);
export const isUnspecifiedCard = (id: string) => string.Eq.equals(id, UNSPECIFIED_CREDIT_CARD_VALUE);

export const formatCardExpiration = (expiration?: string) => {
    if (!expiration) {
        return undefined;
    }

    const { year, month } = parsePaymentCardExpirationDate(expiration);

    return `${year}-${month}`;
};

export const isCardPaymentMethod = (
    paymentMethod: CardPaymentMethod | SepaPaymentMethod
): paymentMethod is CardPaymentMethod => paymentMethod.paymentMethod === PaymentMethod.PaymentCard;
export const isSepaPaymentMethod = (
    paymentMethod: CardPaymentMethod | SepaPaymentMethod
): paymentMethod is SepaPaymentMethod => paymentMethod.paymentMethod === PaymentMethod.SepaDirectDebit;
